/**
 * A disclosure INSIDE a record section (SA-461, spec §7.4): the completed
 * tasks under the open ones, the Options and Revision history under the
 * feasibility decision. The band's "Completed tasks" toggle, made shared.
 * `onOpen` fires on the first open only — the completed tasks fetch then.
 */
import { useId, useRef, useState, type ReactNode } from 'react'
import { ChevronDown, ChevronRight } from 'lucide-react'

export function InnerDisclosure({
  title, defaultOpen = false, onOpen, children,
}: {
  title: string
  defaultOpen?: boolean
  onOpen?: () => void
  children: ReactNode
}) {
  const [open, setOpen] = useState(defaultOpen)
  const opened = useRef(defaultOpen)
  const panelId = useId()
  const Chevron = open ? ChevronDown : ChevronRight
  const toggle = () => {
    const next = !open
    setOpen(next)
    if (next && !opened.current) {
      opened.current = true
      onOpen?.()
    }
  }
  return (
    <div>
      <button type="button" aria-expanded={open} aria-controls={open ? panelId : undefined} onClick={toggle}
        className="inline-flex items-center gap-1 text-xs text-muted-foreground underline-offset-2 hover:underline">
        <Chevron aria-hidden="true" className="size-3" />
        {title}
      </button>
      {open && <div id={panelId} className="mt-1.5">{children}</div>}
    </div>
  )
}
